export default __webpack_public_path__ + "static/media/QueryLanguage.731d4acb.md";